import React, { ReactNode } from 'react';

import { PancakeStack } from '@betterment/samba-react';

import Footer from '../Footer';

const FlowLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <PancakeStack css={{ maxWidth: '100%' }}>
      {children}
      <PancakeStack.Footer
        css={{
          px: 'space.200',
          paragraphSpacing: true,
        }}
      >
        <Footer />
      </PancakeStack.Footer>
    </PancakeStack>
  );
};

export default FlowLayout;
